// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J_z-","rootMobile":"styles_rootMobile__1bLbP"};